export interface ArticleCardReference {
    type: string;
    id: number;
    version: number;
}

export type ArticleContentPart = string | ArticleCardReference;

// The stored format is text inside HTML, not executable markup. Keep this parser
// independent of card components so additional types/versions can be registered.
export function splitArticleCards(text: string): ArticleContentPart[] {
    const parts: ArticleContentPart[] = [];
    const shortcode = /\[ickonic-card\b([^\]\r\n]*)\]/g;
    let end = 0;
    let match: RegExpExecArray | null;

    while ((match = shortcode.exec(text))) {
        const attributes: Record<string, string> = {};
        const attribute = /\s+([a-z][a-z0-9-]*)=(?:"([^"]*)"|'([^']*)')/gy;
        let offset = 0;
        let field: RegExpExecArray | null;
        let valid = true;
        while ((field = attribute.exec(match[1]))) {
            if (Object.prototype.hasOwnProperty.call(attributes, field[1])) valid = false;
            attributes[field[1]] = field[2] ?? field[3];
            offset = attribute.lastIndex;
        }
        const { type, id, version } = attributes;
        if (!valid || match[1].slice(offset).trim() || Object.keys(attributes).length !== 3 ||
            !/^[a-z][a-z0-9-]*$/.test(type ?? "") || !/^[1-9]\d*$/.test(id ?? "") ||
            !/^[1-9]\d*$/.test(version ?? "") || Number(id) > 2147483647 ||
            !Number.isSafeInteger(Number(version))) continue;

        if (match.index > end) parts.push(text.slice(end, match.index));
        parts.push({ type, id: Number(id), version: Number(version) });
        end = shortcode.lastIndex;
    }
    if (end < text.length) parts.push(text.slice(end));
    return parts;
}
